// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__nwRXT","modal":"ErrorModal_modal__AhPQx","titleContainer":"ErrorModal_titleContainer__EYNKc"};